<template lang="pug">
  div.image-uploader
    div(v-if="files.length > 0")
      v-list
        v-list-item(v-for="(file, $index) in files", :key="file.id")
          v-list-item-avatar
            img(:src="getPreview(file)")
          v-list-item-content
            v-list-item-title {{ file.name }}
            v-list-item-subtitle {{ formatFileSize(file.size) }}
          v-list-item-action
            v-btn(icon, @click="dropFile($index)")
              v-icon(color="red") delete
      v-btn(v-if="!uploading" @click="uploadFiles()" color="green" dark)
        v-icon file_upload
        span Subir archivos
    div.upload-button(v-if="!uploading").mt-3
      input.custom-file-input(ref="file", type="file", @change="selectFiles($event)", :accept="accept", :multiple="multiple")
      v-btn(color="primary")
        v-icon search
        span {{buttonText}}
    div(v-if="uploading") Subiendo
</template>

<style lang="postcss" scoped>
.upload-button {
  position: relative;
}

.custom-file-input {
  position: absolute;
  visibility: none;
  opacity: 0.01;
  z-index: 1;
  width: 100%;
  height: 100%;
}
</style>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    autoupload: {
      type: Boolean,
    },
    accept: {
      type: String,
      default: '*',
    },
    endpoint: String,
    buttonText: {
      type: String,
      default: 'Seleccionar archivos',
    },
  },
  data() {
    return {
      inputId: null,
      files: [],
      uploading: false,
    };
  },
  methods: {
    selectFiles(event) {
      const inputFiles = event.target.files;
      for (let x = 0; x < inputFiles.length; x += 1) {
        this.files.push(inputFiles[x]);
        if (this.autoupload) {
          this.uploadFiles();
        }
      }
      this.$refs.file.value = null;
    },
    formatFileSize(size) {
      const sizeInMb = Math.round((size / 1024 / 1024) * 100) / 100;
      return `${sizeInMb}Mb`;
    },
    dropFile(index) {
      this.files.splice(index, 1);
    },
    getPreview(file) {
      return URL.createObjectURL(file);
    },
    uploadFiles() {
      this.uploading = true;

      const data = new FormData();
      data.append('file', this.files[0]);

      api.post(this.endpoint, data, {
        onUploadProgress: (progressEvent) => {
          this.files[0].completed = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      }).then((res) => {
        this.$emit('uploaded', res.data);
        this.files.shift();
        this.uploading = false;
        if (this.files.length > 0) {
          this.uploadFiles();
        }
      }).catch((err) => {
        this.uploading = false;
        this.error = err;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Uploader.vue